// removed by extract-text-webpack-plugin
module.exports = {"list-userinfo":"_userinfo__list-userinfo___ebB4I","news-tab-content":"_userinfo__news-tab-content___W7PLu","userinfo-header":"_userinfo__userinfo-header___vTUgi","userinfo-table":"_userinfo__userinfo-table___pN8Is","userinfo-item":"_userinfo__userinfo-item___1DKil","new-userinfo-item":"_userinfo__new-userinfo-item___3VFq0","userinfo-table-header":"_userinfo__userinfo-table-header___3LLHB","userinfo-table-list":"_userinfo__userinfo-table-list___1Tn9W","btn-see-more-wrap":"_userinfo__btn-see-more-wrap___2Uc8a"};


//////////////////
// WEBPACK FOOTER
// ./components/partials/userinfo/_userinfo.scss
// module id = ./components/partials/userinfo/_userinfo.scss
// module chunks = 0